import React from "react";
import { Route, Routes } from "react-router-dom";
import Landing from "./pages/Landing";
import Header from "./components/Header";
import "./App.scss";
import Footer from "./components/Footer";
import Privacy from "./pages/Privacy";
import Patrika from "./pages/Patrika";
import OfficeBearers from "./pages/OfficeBearers";
import Vanshavali from "./pages/Vanshavali";
import VanshavaliForm from "./pages/VanshavaliForm";
import VanshavaliThankYou from "./pages/VanshavaliThankYou";

function App() {
  const routers = [
    {
      path: "/",
      element: <Landing />,
    },
    {
      path: "privacy_policy",
      element: <Privacy />,
    },
    {
      path: "office_bearers",
      element: <OfficeBearers />,
    },
    {
      path: "patrika",
      element: <Patrika />,
    },
    {
      path: "vanshavali",
      element: <Vanshavali />,
    },
    {
      path: "vanshavali/form",
      element: <VanshavaliForm />,
    },
    {
      path: "vanshavali/form/thank-you",
      element: <VanshavaliThankYou />,
    },
  ];
  return (
    <Routes>
      {routers.map((route, index) => {
        return (
          <Route
            key={index}
            path={route.path}
            element={
              <>
                <Header />
                {route.element}
                <Footer />
              </>
            }
          />
        );
      })}
    </Routes>
  );
}

export default App;
